import React from 'react'
import { toString } from 'lodash'
import BooleanIcon from 'UI/BooleanIcon'

const PowerStateCell = ({ powerState }) => {
  const state = toString(powerState).replace('Powered', '')

  return (
    <BooleanIcon {...{
      booleanValue: state === 'On',
      trueIcon: { text: state, icon: 'power-off' },
      falseIcon: { text: state, icon: 'power-off' }
    }} />
  )
}

export default PowerStateCell
